import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	genericPlaceholderIcon: {
		id: 'dashboard-internal-common.common.gadget.gadget-skeleton.generic-placeholder-icon',
		defaultMessage: 'Placeholder icon',
		description: 'Placeholder icon to represent loading or gadget dragging',
	},
});
